import {ReactNode, useEffect} from 'react';
import {USER_AUTHENTICATED_EVENT} from '~/adapters/ciheader/windowMessages';
import {useAuth} from '~/auth/AuthContext';
import {pushGtmEvent} from '~/utils/analytics';
import {createHexadecimalHash} from '~/adapters/tracking/accountCompoundId';
import {usePersonalAccount} from '~/adapters/services/accounts/accounts/hooks';

export const AuthSuccessTracker = ({children}: {children: ReactNode}) => {
  const {user} = useAuth();
  const {data: personalAccount, isLoading} = usePersonalAccount();

  useEffect(() => {
    if (personalAccount && user && !isLoading) {
      createHexadecimalHash(user.email).then(hexEmail => {
        pushGtmEvent({
          event: 'lab_signin_success',
          account_id: personalAccount.id,
          account_token: `${personalAccount.id}-${hexEmail.substring(0, 5)}`
        });
      });
    }
  }, [personalAccount]);
  return children;
};

export const AuthHeaderLoginListener = ({children}: {children: ReactNode}) => {
  const {loginSilently} = useAuth();

  useEffect(() => {
    window.addEventListener(USER_AUTHENTICATED_EVENT, () => {
      loginSilently();
    });
  }, []);

  return children;
};
